<template>
<div>
  <div class="popBg" @click.prevent.stop="closeDict"></div>

  <div class="popup fixed">
    <div class="popup__inner fixed z-40 max-w-lg rounded p-2">
      <div class="popup__body text-NotoSansRegular text-base py-5 px-4 bg-white">
        <div class="wordDict z-10  cursor-default pt-2 pb-4 px-4" v-if="content">
          <div class="bg-white relative">
            <div class="flex items-center">
              <h5 class="font-black mb-1 text-xl textColorRed mr-2" v-if="content.key" v-html="forceToJap(content.key)"></h5>
              <a @click.prevent.stop="PlayAudioDict()" class="cursor-pointer h-6 w-6 bgLiveBlack rounded-full flex items-center justify-center">
                <font-awesome-icon icon="volume-up" class="text-sm text-white " />
              </a>
            </div>
            <div class="translation_KK mb-1 flex flex-wrap">
              <span v-if="checkPhon">{{ checkPhon }}</span>
              <span class="ml-2" v-if="content.part_of_speech">{{ content.part_of_speech }}</span>
            </div>
            <p class="whitespace-pre-line"> {{ content.expl }}</p>
            <a class="cursor-pointer absolute top-0 right-0 p-1" @click.prevent.stop="closeDict"><font-awesome-icon icon="times" /></a>
          </div>
          <audio v-if="content.key" id='audio' :src="`${BaseUrl}/livelibrary/Dict/Word/${content.key}/audio?lang=${checkLang}`" controlos="controls" ref="audioplayer"></audio>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import langMixin from '@/components/modules/langMixin'
export default {
  name: 'WordDictM',

  data () {
    return {
    }
  },
  mixins: [
    langMixin
  ],
  props: {
    content: {
      type: Object
    }
  },
  computed: {
    BaseUrl () {
      if (process.env.NODE_ENV === 'production') {
        return 'https://api.liveabc.com/v1'
      } else {
        return 'https://apitest.liveabc.com/v1'
      }
    },
    checkLang () {
      if (this.checkJPN(this.getOnlyJp(this.content.key))) {
        return 'ja'
      }
      return 'en'
    },
    checkPhon () {
      let self = this
      if (self.content.phon && self.content.phon.indexOf('[') > -1 && self.content.phon.indexOf(']') > -1) {
        return self.content.phon
      } else if (self.content.phon && self.content.phon.indexOf('[') === -1 && self.content.phon.indexOf(']') === -1) {
        return '[' + self.content.phon + ']'
      } else {
        return ''
      }
    }
  },
  mounted () {
  },
  methods: {
    closeDict () {
      let self = this
      self.$emit('closeDict', -1)
    },
    PlayAudioDict () {
      let self = this
      if (self.$refs.audioplayer) {
        let audioplayer = self.$refs.audioplayer
        // 判斷是否撥放中
        audioplayer.onplaying = () => {
          self.isPlaying = true
        }
        audioplayer.onpause = () => {
          self.isPlaying = false
        }
        // 播放切換
        if (self.isPlaying) {
          audioplayer.pause()
          audioplayer.currentTime = 0
          self.isPlaying = false
        } else {
          audioplayer.play()
          self.isPlaying = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wordDict {
  width: 20em;
  // height: 10em;
  // overflow-y: scroll;
  // left: 10%;
  // top: 105%;
  @media (max-width:768px) {
    // top: 120%;
    width: 100%;
  }
}
// .scrollBar {
//   max-height: 500px;
//   overflow-y: scroll;
// }
.scrollBar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
}

.scrollBar::-webkit-scrollbar {
  width: 6px;
}

.scrollBar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.popBg {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed !important;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
}
.popup {
  z-index: 1000;
  .popup__inner {
    top: 35%;
    @media (max-width:768px) {
      top: 25%;
    }
    left: 0;
    right: 0;
    margin: 0 auto;
    line-height: 1.5;
    letter-spacing: .05em;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    -webkit-transform: scale(0.3);
    -moz-transform: scale(0.3);
    -ms-transform: scale(0.3);
    -o-transform: scale(0.3);
    transform: scale(0.3);

    -webkit-animation-name: example;
    -webkit-animation-duration: .3s;
    animation-name: example;
    animation-duration: .3s;
    animation-fill-mode: forwards;
    .popup__header {
      margin-bottom: 15px;
      font-size: 0.85em;
      font-weight: bold;
    }
    .popup__body {
      font-size: 0.85em;
      .english {
        .enWord {
          margin-right: 2px;
        }
      }
    }
    .popup__buttons {
      text-align: right;
    }
  }
}
@-webkit-keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(1);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}

/* Standard syntax */
@keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(1);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
  }
}
</style>
